__turbopack_context__.v({
  "embeddedEntry": "lFJfHq_embeddedEntry",
  "richTextContent": "lFJfHq_richTextContent",
  "textLink": "lFJfHq_textLink",
});
